import { Box, TextButton, IconChevronLeftOutline } from '@zillow/constellation';
import { yieldCallback } from '@zillow/yield-callback';
import React from 'react';
import { useCurrentUser } from '../../hooks/user.js';
import { GROUP_WIDTH_MAP } from '../../mixins/components/GroupMixin.js';
import { getCmsInfoForPage } from '../../utils/clickstream/getCmsInfoForPage.js';
import { usePageProps } from '../PagePropsProvider/PagePropsProvider.js';
import { sendEvent } from './B2BUserNav.utils.js';
import SignIn from './SignIn.js';

var B2BUserNav = function B2BUserNav(props) {
  var signInLink = props.signInLink,
    redirectParam = props.redirectParam,
    router = props.router,
    env = props.env,
    transparent = props.transparent;
  var pageProps = usePageProps();
  var cmsInfo = getCmsInfoForPage(pageProps);
  var _useCurrentUser = useCurrentUser(env),
    user = _useCurrentUser.data.user;
  return /*#__PURE__*/React.createElement(Box, {
    sx: {
      position: 'relative',
      borderBottom: '$borderWidths.xs solid $colors.borderLight',
      background: transparent ? 'rgba(0, 0, 0, 0)' : '$colors.backgroundWhite',
      '@media $lg_lte': {
        position: 'relative',
        height: 'auto',
        width: '100%'
      }
    }
  }, /*#__PURE__*/React.createElement(Box, {
    sx: {
      display: 'flex',
      justifyContent: 'space-between',
      maxWidth: GROUP_WIDTH_MAP.xl,
      margin: '0 auto',
      padding: '$spacing.xs $spacing.sm'
    }
  }, /*#__PURE__*/React.createElement(Box, {
    sx: {
      display: 'flex',
      alignItems: 'center',
      gap: '$spacing.xs'
    }
  }, /*#__PURE__*/React.createElement(TextButton, {
    buttonType: "tertiary",
    inverse: transparent,
    as: "a",
    href: "/",
    fontType: "bodySmall",
    icon: /*#__PURE__*/React.createElement(IconChevronLeftOutline, null),
    iconSize: "xs",
    onClick: yieldCallback(function () {
      sendEvent('cms_anchor', 'Zillow Home', 'https://www.zillow.com/', cmsInfo);
    })
  }, "Zillow Home")), /*#__PURE__*/React.createElement(SignIn, {
    user: user,
    inverse: transparent,
    signInLink: signInLink,
    redirectParam: redirectParam,
    router: router,
    env: env
  })));
};
var B2BUserNav$1 = B2BUserNav;

export { B2BUserNav$1 as default };
